import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { PropertyOriginDestinationSyncResultDto } from '../dtos/property-origin-destination/models';

@Injectable({
  providedIn: 'root',
})
export class PropertyOriginDestinationPlanningOrchestratorService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  obtainPropertyOriginDestinationFromGis = (cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PropertyOriginDestinationSyncResultDto>({
      method: 'POST',
      url: '/api/orchestrator/planning/property-origin-destinations/obtain-from-gis',
    },
    { apiName: this.apiName,...config });
}